import { EInfrastructureType } from '../../types/offer';
import { IOfferDesktopSchema } from '../../repositories/offers-comparison/entities/offer/OfferDesktopSchema';

export function transformComparisonNewbuilding({ newbuilding }: IOfferDesktopSchema) {
  if (!newbuilding) {
    return null;
  }

  return {
    ...newbuilding,
    infrastructure: newbuilding.infrastructure?.map(infrastructure => ({
      ...infrastructure,
      type: infrastructure.type as unknown as EInfrastructureType,
    })),
  };
}
